<template>
  <div class="home">
    <h3>Data Pengajuan Sertifikat</h3>

    <div class="card">
      <div class="card-body">
        <p style="font-size: 14px">Filter Data</p>
        <form @submit.prevent="loadData" class="form-filter">
          <input type="text" placeholder="Cari Nama / No Daftar..." v-model="filter.nama" />
          <select v-model="filter.id_kampus">
            <option value="semua">Semua Kampus</option>
            <option value="1">Lampung</option>
            <option value="2">Jakarta</option>
            <option value="3">Yogyakarta</option>
            <option value="5">Makassar</option>
            <option value="6">Bali</option>
          </select>
          <select v-model="filter.angkatan">
            <option value="semua">Semua Angkatan</option>
            <option v-for="item, index in angkatan" :key="index" :value="item">{{ item }}</option>
          </select>
          <date-range-picker v-model="dateRange">
            <template v-slot:input="picker" style="min-width: 350px">
              {{ picker.startDate | date }} - {{ picker.endDate | date }}
            </template>
          </date-range-picker>
          <button type="submit" class="btn-primary">CARI</button>
          <div></div>
          <button type="button" class="btn-excel" @click="exportExcel">
            EXPORT EXCEL
          </button>
        </form>

        <div class="table-block">
          <table class="table" id="table">
            <thead>
              <tr>
                <th>#</th>
                <th>Kampus</th>
                <th>Angkatan</th>
                <th>No Daftar</th>
                <th>Nama Siswa</th>
                <th>No Telp</th>
                <th>Penerima</th>
                <th>Alamat Penerima</th>
                <th>Tgl Diajukan</th>
                <th>Pembayaran</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody v-if="!loading">
              <tr v-for="(item, k) in data" :key="k" @click="openModal(k)">
                <td>{{ k + 1 }}</td>
                <td>{{ item.kampus }}</td>
                <td>{{ item.angkatan }}</td>
                <td>{{ item.nodaf_siswa }}</td>
                <td>{{ item.nama_lengkap }}</td>
                <td>{{ item.no_telp }}</td>
                <td>{{ item.nama_penerima }}</td>
                <td>
                  {{ item.alamat_pengiriman }}
                  {{ item.kelurahan }}
                  {{ item.kecamatan }}
                  {{ item.kabupaten }}
                  {{ item.provinsi }}
                  {{ item.kodepos }}
                </td>
                <td>{{ moment(item.tgl_diajukan).format("DD MMM YYYY") }}</td>
                <td>{{ item.status_bayar }}</td>
                <td>
                  <span :class="'badge-' + item.status.toLowerCase()">
                    {{ item.status }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p style="text-align: center" v-if="loading">
          <loading />
        </p>
      </div>
    </div>

    <div class="modal" v-if="modalOpen" @click="closeModal">
      <div class="modal-body">
        <div class="modal-close">
          <div @click="modalOpen = false">
            <close />
          </div>
        </div>
        <div class="form">
          <div class="form-group">
            <div style="
                display: grid;
                grid-template-columns: 100px 1fr;
                grid-column-gap: 15px;
              ">
              <div>
                <label for="">No Daftar</label>
                <input type="text" :value="siswa.nodaf_siswa" readonly />
              </div>
              <div>
                <label for="">Nama Siswa</label>
                <input type="text" :value="siswa.nama_lengkap" readonly />
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="">Nama Penerima</label>
            <input type="text" v-model="siswa.nama_penerima" />
          </div>
          <div class="form-group">
            <label for="">No Telp</label>
            <input type="text" v-model="siswa.no_telp" />
          </div>
          <div class="form-group">
            <label for="">Alamat</label>
            <textarea v-model="siswa.alamat_pengiriman"></textarea>
          </div>
          <div class="form-group">
            <label for="">Provinsi</label>
            <select v-model="siswa.id_provinsi" @change="loadKabupaten(siswa.id_provinsi)">
              <option value=""></option>
              <option :value="item.id" v-for="(item, index) in lokasi.provinsi" :key="index">
                {{ item.nama }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="">Kabupaten</label>
            <select v-model="siswa.id_kabupaten" @change="loadKecamatan(siswa.id_kabupaten)">
              <option value=""></option>
              <option :value="item.id" v-for="(item, index) in lokasi.kabupaten" :key="index">
                {{ item.nama }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="">Kecamatan</label>
            <select v-model="siswa.id_kecamatan" @change="loadKelurahan(siswa.id_kecamatan)">
              <option value=""></option>
              <option :value="item.id" v-for="(item, index) in lokasi.kecamatan" :key="index">
                {{ item.nama }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="">Kelurahan</label>
            <select v-model="siswa.id_kelurahan" @change="loadKodepos(siswa.id_kelurahan)">
              <option value=""></option>
              <option :value="item.id" v-for="(item, index) in lokasi.kelurahan" :key="index">
                {{ item.nama }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="">Kodepos</label>
            <input type="text" v-model="siswa.kodepos" />
          </div>

          <div class="form-group" v-if="siswa.status == 'DIKIRIM'">
            <label for="">Ekspedisi</label>
            <p>{{ siswa.ekspedisi || "-" }}</p>
          </div>
          <div class="form-group" v-if="siswa.status == 'DIKIRIM'">
            <label for="">No Resi</label>
            <p>{{ siswa.no_resi || "-" }}</p>
          </div>
          <div class="form-group" v-if="siswa.status == 'DIKIRIM' || siswa.status == 'RETUR'">
            <label for="">Bukti Pengiriman</label>
            <p>
              <img :src="siswa.bukti_pengiriman +
          '?v=' +
          moment().format('DDMMYYHHiiss')
          " width="100%" />
            </p>

            <form @submit.prevent="retur()">
              <div class="form-group">
                <label>Alasan Retur</label>
                <textarea v-model="siswa.alasan_retur"></textarea>
                <small v-show="submitRetur && !siswa.alasan_retur" style="color: red">Alasan harus diisi</small>
              </div>
              <div style="display: flex;justify-content: space-between;">
                <button type="submit" class="btn btn-tolak" :disabled="siswa.status == 'RETUR'">
                  RETUR
                </button>
                <button type="button" class="btn btn-validasi" @click="batalValidasi" v-show="siswa.status == 'RETUR'">
                  Belum Validasi
                </button>
              </div>
            </form>
          </div>

          <div class="form-group" v-if="siswa.status == 'VALIDASI'">
            <label for="">Ekspedisi</label>
            <input type="text" v-model="siswa.ekspedisi" />
          </div>
          <div class="form-group" v-if="siswa.status == 'VALIDASI'">
            <label for="">No Resi</label>
            <input type="text" v-model="siswa.no_resi" />
          </div>
          <div class="form-group" v-if="siswa.status == 'VALIDASI'">
            <label for="">Upload Bukti Pengiriman</label>
            <input type="file" ref="bukti_pengiriman" accept="image/jpeg" />
          </div>
          <div class="form-group" v-if="openDitolak || siswa.status == 'DITOLAK'">
            <label for="">Alasan Ditolak</label>
            <input type="text" v-model="siswa.alasan_ditolak" />
          </div>
          <div class="form-group">
            <button type="button" class="btn btn-update" @click="updateData" v-show="!openDitolak" v-if="siswa.status == 'PENDING' ||
          siswa.status == 'DITOLAK' ||
          siswa.status == 'BELUM VALIDASI'
          ">
              Update Data
            </button>
            <button type="button" class="btn btn-validasi" @click="validasi" v-show="!openDitolak" v-if="siswa.status == 'PENDING' ||
          siswa.status == 'DITOLAK' ||
          siswa.status == 'BELUM VALIDASI'
          ">
              Validasi
            </button>
            <button type="button" class="btn" @click="updatePengiriman" v-if="siswa.status == 'VALIDASI'">
              Update Pengiriman
            </button>
            <button type="button" class="btn btn-tolak" @click="batalValidasi" v-if="siswa.status == 'VALIDASI'">
              Batalkan Validasi
            </button>
            <button type="button" class="btn btn-tolak" @click="pending" v-if="siswa.status == 'VALIDASI'">
              Pending
            </button>
            <button type="button" class="btn btn-tolak" @click="openDitolak = true" style="float: right"
              v-show="!openDitolak" v-if="siswa.status == 'PENDING' || siswa.status == 'BELUM VALIDASI'
          ">
              Tolak
            </button>

            <button type="button" class="btn btn-tolak" style="width: 100%" v-if="openDitolak" @click="tolakPengajuan">
              TOLAK PENGAJUAN
            </button>
          </div>
          <p style="text-align: center" v-if="loadingForm">
            <loading />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Close from "./icons/Close.vue";
import Options from "./icons/Options.vue";
import Loading from "./icons/Loading.vue";
import Download from "./icons/Download.vue";

import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import moment from "moment";
import axios from "axios";
import Table2Excel from "table2excel";
import * as api from "../api/Api";

export default {
  name: "Sertifikat",
  components: {
    Close,
    Options,
    Loading,
    Download,
    DateRangePicker,
  },
  data() {
    return {
      loading: false,
      loadingForm: false,
      popoverOpen: false,
      modalOpen: false,
      file: null,
      data: [],
      tmpData: [],
      siswa: {},
      filter: {
        nama: "",
        no_daftar: "",
        status: "",
        id_kampus: "semua",
        angkatan: "semua",
      },
      dateRange: {
        startDate: null,
        endDate: null,
      },
      lokasi: {
        provinsi: [],
        kabupaten: [],
        kecamatan: [],
        kelurahan: [],
        kodepos: [],
      },
      openDitolak: false,

      submitRetur: false,
      angkatan: []
    };
  },
  methods: {
    moment,
    togglePopover() {
      this.popoverOpen = !this.popoverOpen;
    },
    closePopover() {
      this.popoverOpen = false;
    },
    openModal(k) {
      console.log(this.data[k]);
      this.openDitolak = false;
      this.siswa = this.data[k];
      this.loadProvinsi();

      this.modalOpen = true;
    },
    to(to) {
      setTimeout(() => {
        this.$router.push(to);
      }, 150);
    },
    loadData() {
      const realFilter = {};
      if (this.filter.nama != "") {
        realFilter.nama = this.filter.nama;
        realFilter.no_daftar = this.filter.nama;
      }
      if (this.filter.status != "" && this.filter.status != "SEMUA") {
        realFilter.status = this.filter.status;
      }
      if (this.dateRange.startDate != null) {
        realFilter.tgl_awal = moment(this.dateRange.startDate).format(
          "YYYY-MM-DD"
        );
        realFilter.tgl_akhir = moment(this.dateRange.endDate).format(
          "YYYY-MM-DD"
        );
      }
      if (this.filter.id_kampus != 'semua') {
        realFilter.id_kampus = this.filter.id_kampus;
      }
      if (this.filter.angkatan != 'semua') {
        realFilter.angkatan = this.filter.angkatan;
      }

      this.loading = true;

      const queryString = Object.keys(realFilter)
        .map((key) => key + "=" + realFilter[key])
        .join("&");
      api
        .get("/v1/SertifikatController/getAll?" + queryString)
        .then((r) => {
          this.loading = false;

          this.data = r.data;
          this.tmpData = r.data;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    updateData() {
      this.loadingForm = true;
      console.log("update");
      api.post("/v1/SertifikatController/updateData", this.siswa).then((r) => {
        this.modalOpen = false;
        this.loadingForm = false;
        this.loadData();
      });
    },
    validasi() {
      this.loadingForm = true;
      api.post("/v1/SertifikatController/validasi", this.siswa).then((r) => {
        this.modalOpen = false;
        this.loadingForm = false;
        this.loadData();
      });
    },
    batalValidasi() {
      if (confirm("Batalkan Validasi?")) {
        api
          .post("/v1/SertifikatController/cancelValidasi", this.siswa)
          .then((r) => {
            this.modalOpen = false;
            this.loadingForm = false;
            this.loadData();
          });
      }
    },
    pending() {
      if (confirm("Ubah ke pending?")) {
        api
          .post("/v1/SertifikatController/pendingValidasi", this.siswa)
          .then((r) => {
            this.modalOpen = false;
            this.loadingForm = false;
            this.loadData();
          });
      }
    },
    tolakPengajuan() {
      if (!this.siswa.alasan_ditolak) {
        alert("Alasan ditolak harus diisi");
        return;
      }

      this.loadingForm = true;
      api.post("/v1/SertifikatController/reject", this.siswa).then((r) => {
        this.modalOpen = false;
        this.loadingForm = false;
        this.loadData();
      });
    },
    retur() {
      this.submitRetur = true;

      if (!this.siswa.alasan_retur) {
        return;
      }

      if (confirm("Retur Sertifikat?")) {
        this.loadingForm = true;
        api.post("/v1/SertifikatController/retur", this.siswa).then((r) => {
          this.modalOpen = false;
          this.loadingForm = false;
          this.loadData();
        });
      }
    },
    updatePengiriman() {
      const self = this;

      if (
        !this.siswa.ekspedisi ||
        !this.siswa.no_resi ||
        this.$refs.bukti_pengiriman.files.length <= 0
      ) {
        alert("Silakan lengkapi form");
        return;
      }

      const data = new FormData();
      data.append("id", this.siswa.id);
      data.append("ekspedisi", this.siswa.ekspedisi);
      data.append("no_resi", this.siswa.no_resi);
      data.append("bukti_pengiriman", this.$refs.bukti_pengiriman.files[0]);

      this.loadingForm = true;
      axios
        .post(
          "https://api.pspp-integrated.com/api/v1/SertifikatController/updatePengiriman",
          data
        )
        .then(function (res) {
          self.modalOpen = false;
          self.loadingForm = false;
          self.loadData();
        })
        .catch(function (err) {
          console.log(err.message);
        });
    },
    cari() {
      this.popoverOpen = false;
      this.loadData();
    },
    exportExcel() {
      const realFilter = {};
      if (this.filter.nama != "") {
        realFilter.nama = this.filter.nama;
        realFilter.no_daftar = this.filter.nama;
      }
      if (this.filter.status != "" && this.filter.status != "SEMUA") {
        realFilter.status = this.filter.status;
      }
      if (this.dateRange.startDate != null) {
        realFilter.tgl_awal = moment(this.dateRange.startDate).format(
          "YYYY-MM-DD"
        );
        realFilter.tgl_akhir = moment(this.dateRange.endDate).format(
          "YYYY-MM-DD"
        );
      }

      const queryString =
        "?" +
        Object.keys(realFilter)
          .map((key) => key + "=" + realFilter[key])
          .join("&");

      location.href =
        "https://api.pspp-integrated.com/api/v1/SertifikatController/download" +
        queryString;
    },
    loadProvinsi() {
      api.get("/v1/LokasiController/provinsi").then((r) => {
        this.lokasi.provinsi = r;
        this.loadKabupaten(this.siswa.id_provinsi);
      });
    },
    loadKabupaten(id_provinsi) {
      api
        .get("/v1/LokasiController/kabupaten?id_provinsi=" + id_provinsi)
        .then((r) => {
          this.lokasi.kabupaten = r;
          this.loadKecamatan(this.siswa.id_kabupaten);
        });
    },
    loadKecamatan(id_kabupaten) {
      api
        .get("/v1/LokasiController/kecamatan?id_kabupaten=" + id_kabupaten)
        .then((r) => {
          this.lokasi.kecamatan = r;
          this.loadKelurahan(this.siswa.id_kecamatan);
        });
    },
    loadKelurahan(id_kecamatan) {
      api
        .get("/v1/LokasiController/kelurahan?id_kecamatan=" + id_kecamatan)
        .then((r) => {
          this.lokasi.kelurahan = r;
        });
    },
    loadKodepos() {
      const kelurahan = this.lokasi.kelurahan.find((k) => {
        return k.id == this.siswa.id_kelurahan;
      });
      this.siswa.kodepos = kelurahan.kode_pos;
    },
    closeModal(e) {
      if (e.target.classList[0] == "modal") {
        this.modalOpen = false;
      }
    },
    loadAngkatan() {
      api
        .get("/v1/SertifikatController/angkatan")
        .then((r) => {
          this.angkatan = r;
        });
    }
  },
  mounted() {
    this.filter.status = this.$route.params.status.toUpperCase();
    this.loadAngkatan()
    this.loadData();
  },
  watch: {
    $route(to) {
      this.filter.status = to.params.status.toUpperCase();
      this.loadData();
    },
  },
};
</script>

<style scoped lang="scss">
.home {
  padding: 15px 15px 0px 15px;

  h3 {
    margin: 0 0 15px;
  }

  .navbar {
    display: flex;
    justify-content: space-between;

    a {
      color: #333;
      text-decoration: none;
      display: flex;
      align-items: center;

      .icon {
        margin-left: 5px;
        width: 20px;
      }
    }
  }

  .card {
    background: #fff;
    border-radius: 4px;
    box-shadow: 0px 0px 4px #999;

    .card-filter {
      display: flex;
      justify-content: flex-end;
      padding: 15px;
      text-align: right;
      position: relative;

      .popup {
        position: absolute;
        background: #fff;
        padding: 15px;
        border: 1px solid #ccc;
        border-radius: 6px;
        margin-top: 50px;
        margin-right: 140px;
        text-align: left;
        box-shadow: 0px 20px 40px #bbb;
      }
    }

    .card-body {
      padding: 0px 20px;
      height: calc(100vh - 120px);
      display: block;
      overflow: auto;

      .form-filter {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
        grid-column-gap: 15px;
        margin-bottom: 15px;
      }
    }
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;

    thead {
      th {
        background-color: #eee;
        padding: 8px;
        text-align: left;
        text-transform: uppercase;
        white-space: nowrap;

        &:nth-child(1) {
          width: 20px;
        }

        &:nth-child(2) {
          width: 30px;
        }

        &:nth-child(3) {
          width: 20px;
        }

        &:nth-child(4) {
          width: 60px;
        }

        &:nth-child(5) {
          width: 180px;
        }

        &:nth-child(6) {
          width: 80px;
        }

        &:nth-child(7) {
          width: 180px;
        }
      }
    }

    tbody {
      tr {
        cursor: pointer;
      }

      tr:hover {
        td {
          background-color: #f7f7f7;
        }
      }

      td {
        padding: 8px;
        text-align: left;
        border-bottom: 1px solid #eee;
        vertical-align: top;
      }
    }
  }

  .badge-pending {
    font-size: 12px;
    background-color: #ffe600;
    padding: 4px 12px;
    border-radius: 4px;
    width: 60px;
    display: block;
    text-align: center;
  }

  .badge-dikirim {
    font-size: 12px;
    background-color: #b3ff00;
    padding: 4px 12px;
    border-radius: 4px;
    width: 60px;
    display: block;
    text-align: center;
  }

  .badge-validasi {
    font-size: 12px;
    background-color: #03ebb8;
    padding: 4px 12px;
    border-radius: 4px;
    width: 60px;
    display: block;
    text-align: center;
  }

  .badge-ditolak {
    font-size: 12px;
    background-color: #eb3103;
    color: #fff;
    padding: 4px 12px;
    border-radius: 4px;
    width: 60px;
    display: block;
    text-align: center;
  }

  .form {
    .form-group {
      margin-bottom: 15px;

      label {
        display: block;
        margin-bottom: 5px;
        font-size: 14;
      }

      p {
        margin-top: 5px;
        font-weight: 600;
      }
    }
  }

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: flex-start;

    .modal-body {
      margin-top: 50px;
      background: #fff;
      border-radius: 6px;
      padding: 20px;
      width: 450px;
      max-height: 500px;
      overflow-y: auto;

      .modal-close {
        position: relative;
        height: 20px;

        .icon {
          position: absolute;
          right: -10px;
          top: -10px;
          width: 30px;
          cursor: pointer;
        }
      }
    }
  }

  .btn {
    padding: 10px 15px;
    text-align: center;
    text-transform: uppercase;

    &.btn-update {
      background: #fff;
      border: 1px solid #007bff;
      color: #007bff;
    }

    &.btn-tolak {
      background: #fff;
      border: 1px solid #f00;
      color: #f00;

      &:active {
        background: #eee;
      }

      &:disabled {
        border-color: rgb(255, 184, 184);
        color: rgb(255, 184, 184);
      }
    }
  }

  .vue-daterange-picker {
    display: block;
  }

  .btn-excel {
    background: #28a745;
  }
}
</style>
<style>
.reportrange-text {
  padding: 10px !important;
  border-radius: 4px !important;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Sertifikat.vue